// Apple Card Style Overrides
// ─────────────────────────────────────────────────────────────────────────────

export default function Card(theme) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 20px rgba(0,0,0,0.06), 0 0 0 0.5px rgba(60,60,67,0.08)',
          border: '1px solid rgba(255,255,255,0.65)',
          borderRadius: 16,
          backgroundColor: 'rgba(255,255,255,0.80)',
          backdropFilter: 'blur(20px) saturate(160%)',
          WebkitBackdropFilter: 'blur(20px) saturate(160%)',
          overflow: 'hidden',
          position: 'relative',
          zIndex: 0,
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { variant: 'h6' },
        subheaderTypographyProps: { variant: 'body2' },
      },
      styleOverrides: {
        root: {
          padding: '20px 20px 0',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 20,
        },
      },
    },
  };
}
